export default __webpack_public_path__ + "static/media/sponsor-banner.e787ae88.webp";